export default "__VITE_ASSET__C86Vn53u__"